import { Link } from 'react-router-dom';

export const Brand = ({ footer = false }) => (
  <Link className="brand-wordmark" to="/" data-testid={footer ? 'footer-brand-home' : 'interior-brand-home'} aria-label="Longhorn Milling — Home">
    <img src="/assets/longhorn-wordmark.png" width="849" height="177" alt="Longhorn Milling" data-testid={footer ? 'footer-brand-image' : 'interior-brand-image'} />
  </Link>
);